import { render, staticRenderFns } from "./btnAccion.vue?vue&type=template&id=18739de3&"
import script from "./btnAccion.vue?vue&type=script&lang=js&"
export * from "./btnAccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports